import { createContext, useContext } from "react";

export const AccessTokenContext = createContext<() => string | undefined>(
  () => undefined
);

export const useAccessToken = () => useContext(AccessTokenContext);
